import { useState, useEffect } from 'react';
import passiveArg from 'bdvp-common/src/utils/passiveArg';

const useFixElement = (myRef, top, isDisabled) => {

    const [
        shouldFixElement,
        setShouldFixElement,
    ] = useState(false);

    useEffect(() => {

        if (isDisabled || !myRef.current) {

            setShouldFixElement(false);
            return;

        }

        setShouldFixElement(myRef.current.getBoundingClientRect().top <= top);
        const onScroll = () => {

            setShouldFixElement(myRef.current.getBoundingClientRect().top <= top);

        };

        window.addEventListener('scroll', onScroll, passiveArg);

        return () => window.removeEventListener('scroll', onScroll);

    }, [
        isDisabled,
        myRef,
        setShouldFixElement,
        top,
    ]);

    return shouldFixElement;

};

export default useFixElement;